// extracted by mini-css-extract-plugin
export default {"skeleton":"hDBImz","avatarSkeleton":"PHsl0L","shimmerSlide":"bSnBec","textSkeleton":"IQQ_2p"};